import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import RouterList from './RouterList';
import { setStorage, authLocalStorage, localGetStorage } from '@/lib/storage';
import { Fragment, useEffect } from 'react';
import { LOCAL_SESSION } from '@/lib/common/name-space';
import { toast } from 'react-toastify';
import { useWeb3AuthDisconnect } from '@web3auth/modal/react';
import { useWeb3AuthConnect } from '@web3auth/modal/react';
import { useWeb3 } from '@/contexts/web3Provider';

type routerProps = {
  path: string;
};
export default function Router({ path }: routerProps) {
  // '/' 두 개일 경우
  const length = path.split('/').length - 1;
  // 삼항?

  if (length > 2) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path/:type`;
  } else if (length > 1) {
    const temp = path.split('/');
    path = `/${temp[1]}/:path`;
  }
  const list = RouterList();
  const routeList = list.filter((item) => path === item.url);
  if (routeList.length === 0) {
    return <></>;
    // TODO 완료 후 삭제
    // return <Navigate to="/signIn" />;
  }
  const route = routeList[0];

  return (
    <>
      <Routes>
        {route.private === true ? (
          <>
            <Route path={route.url} element={<PrivateRoute element={route.element} url={route.url} />} />
          </>
        ) : (
          <Route path={route.url} element={route.element} />
        )}
      </Routes>
    </>
  );
}

type PrivateProps = {
  element: JSX.Element;
  url: string;
};
const PrivateRoute = ({ element, url }: PrivateProps) => {
  const { disconnect } = useWeb3AuthDisconnect();
  const { isConnected } = useWeb3AuthConnect();
  const { clearWeb3Auth } = useWeb3();
  const navigate = useNavigate(); // useNavigate 훅 사용

  // const session = localGetStorage(LOCAL_SESSION);
  // const isSessionValid = session && new Date().getTime() <= session.sessionTime;

  // 세션 유효성 검사 로직을 useEffect로 분리
  useEffect(() => {
    // 세션이 유효하지 않은 경우
    // if (!isSessionValid) {
    //   toast.error('세션이 만료되었거나 유효하지 않습니다.');
    //   localStorage.removeItem(LOCAL_SESSION);

    // }
    // Web3 연결이 되어있다면 연결 해제
    if (isConnected) {
      // (async () => {
      //   await disconnect();
      //   // disconnect 후에 페이지 이동q
      //   navigate('/signInSns');
      // })();
    } else {
      // 연결이 안 되어있다면 바로 페이지 이동
      (async () => {
        await disconnect();
        clearWeb3Auth();
        navigate('/signInSns');
      })();
    }
  }, [isConnected, disconnect, navigate]); // 의존성 배열에 필요한 값들을 추가

  // 세션이 유효할 때만 자식 엘리먼트를 렌더링하고,
  // 유효하지 않다면 null을 반환하여 useEffect가 처리할 때까지 기다립니다.
  return element;
};
